'use strict';
module.exports = function (str, length) {
	return str.length > length ? str.slice(0, length) + '...' : str;
};
